import { render } from "./Licencas.vue?vue&type=template&id=309fca30"
import script from "./Licencas.vue?vue&type=script&lang=js"
export * from "./Licencas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__